var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('HelloWorld',{attrs:{"user":_vm.user}}),_c('post',{attrs:{"login":_vm.user.login,"result":_vm.result}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }